import './BuilderOrder.scss';
import MicroModal from 'micromodal';

export default class BuilderOrder {

	constructor () {
		this.modalTriggers = document.getElementsByClassName('js-builder-order-trigger');
		this.modalID = 'modal-builderorder-init';

		this.bindEvents();
	}

	bindEvents () {
		for (const modalTrigger of this.modalTriggers) {
			modalTrigger.addEventListener('click', (e) => this.openModal(e));
		}

		const searchTriggers = document.getElementsByClassName('js-builder-order-search-trigger');
		const searchInput = document.getElementById('x-search-preview_global--input');
		if (searchInput) {
			for (const searchTrigger of searchTriggers) {
				searchTrigger.addEventListener('click', () => {

					/* Trigger focus so it uses the previous functionality */
					searchInput.dispatchEvent(new Event('focus', {
						bubbles: false,
						cancelable: true
					}));

					searchInput.focus();
				});
			}
		}

		const builderOrderWidgets = document.getElementsByClassName('js-builder-order-widget');
		for (const builderOrderWidget of builderOrderWidgets) {
			const toggle = builderOrderWidget.querySelector('.js-builder-order-widget__toggle');
			if (!toggle) {
				continue;
			}

			toggle.addEventListener('click', () => {
				builderOrderWidget.classList.toggle('t-builder-order-widget--open');
			});
		}
	}

	openModal (e) {
		e?.preventDefault();

		MicroModal.show(this.modalID, {
			awaitCloseAnimation: true,
			awaitOpenAnimation: true,
			disableScroll: true
		});
	}

}
